import React from "react";

function WhitelistTable({ whitelist, isLoading, onRemove, onRefresh }) {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString();
  };

  const getBadgeClass = (status) => {
    switch (status) {
      case 'whitelisted':
        return 'bg-success';
      case 'failed':
        return 'bg-danger';
      case 'pending':
        return 'bg-warning';
      default:
        return 'bg-secondary';
    }
  };

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <div className="mt-2">Loading whitelist...</div>
      </div>
    );
  }

  if (whitelist.length === 0) {
    return (
      <div className="text-center py-5">
        <i className="fas fa-list fa-3x text-muted mb-3"></i>
        <h5 className="text-muted">No IP addresses in whitelist</h5>
        <p className="text-muted">Start by adding your first IP address to the whitelist.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0">
          <i className="fas fa-table me-2"></i>
          Whitelist Entries ({whitelist.length})
        </h5>
        <button 
          className="btn btn-outline-primary btn-sm"
          onClick={onRefresh}
        >
          <i className="fas fa-sync-alt me-1"></i>
          Refresh
        </button>
      </div>

      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-dark">
            <tr>
              <th>IP Address</th>
              <th>Description</th>
              <th>Status</th>
              <th>BitNinja Status</th>
              <th>Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {whitelist.map((ip) => (
              <tr key={ip.id}>
                <td>
                  <code className="bg-light px-2 py-1 rounded">
                    {ip.ip_address}
                  </code>
                </td>
                <td>
                  {ip.description || (
                    <span className="text-muted fst-italic">No description</span>
                  )}
                </td>
                <td>
                  <span className={`badge ${ip.is_active ? 'bg-success' : 'bg-secondary'}`}>
                    {ip.is_active ? 'Active' : 'Inactive'}
                  </span>
                </td>
                <td>
                  <span className={`badge ${getBadgeClass(ip.bitninja_status)}`}>
                    {ip.bitninja_status || 'unknown'}
                  </span>
                </td>
                <td>
                  <small className="text-muted">
                    {formatDate(ip.created_at)}
                  </small>
                </td>
                <td>
                  <div className="btn-group btn-group-sm">
                    <button
                      className="btn btn-outline-danger"
                      onClick={() => onRemove(ip.id, ip.ip_address)}
                      title={`Remove ${ip.ip_address}`}
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="row mt-3">
        <div className="col-12">
          <div className="alert alert-info">
            <i className="fas fa-info-circle me-2"></i>
            <strong>BitNinja Status:</strong>
            <span className="badge bg-success ms-2">whitelisted</span> Successfully added to BitNinja
            <span className="badge bg-danger ms-2">failed</span> Failed to add to BitNinja
            <span className="badge bg-warning ms-2">pending</span> Processing
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhitelistTable;